import useMutationObserver from './useMutationObserver'

export default useMutationObserver
